<template>
  <AuthCard>
    <Form action="/registration" @success="onSuccess">
      <div class="container px-0">
        <div v-if="message" class="row">
          <div class="col">
            <div class="alert alert-success text-center">
              {{ message }}
            </div>
          </div>
        </div>

        <div v-if="!message"
             v-for="(field, name) in fields"
             class="row"
        >
          <div class="col">
            <FormControl
                :name="name"
                :type="name === 'client.birth_date' ? 'datepicker' : 'text'"
                :label="$t(`validation.attributes.${field.attribute}`)"
            />
          </div>
        </div>

        <Captcha v-if="captcha && !message" />

        <div class="row mt-5">
          <div class="col">
            <Button v-if="!message" type="submit" class="btn-primary btn-lg btn-rounded w-100">
              {{ $t('front.register') }}
            </Button>

            <a :href="makeLink('/auth/login')"
               @click.prevent="router.push({ name: 'auth.login'})"
               class="btn btn-lg btn-rounded w-100 borderless mt-2 text-primary"
            >
              {{ !message ? $t('global.back') : $t('front.sign_in') }}
            </a>
          </div>
        </div>
      </div>
    </Form>
  </AuthCard>
</template>
<script setup>
import Form from "@/js/Elements/Form/Form.vue";
import FormControl from "@/js/Elements/Form/FormControl.vue";
import {useRouter} from "vue-router";
import Button from "@/js/Elements/Button.vue";
import {computed, ref} from "vue";
import AuthCard from "@/js/Views/Auth/AuthCard.vue";
import {makeLink} from "@/js/Plugins/Http.js";
import Captcha from "@/js/Elements/Form/Captcha.vue";

const router = useRouter();
const message = ref();

const captcha = computed(() => window.setup.login?.captcha);
const fields = computed(() => {
  return window.setup?.registration && Object.keys(window.setup?.registration).length ? window.setup.registration : { email: { attribute: 'email' }};
});

function onSuccess(response) {
  message.value = response?.message || response?.notify?.message;
}
</script>